import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-charcoal-600 bg-charcoal-900 py-14" data-id="element-72" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-73" data-mp="3gg0yw2enzvx4">
        <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-74" data-mp="32o4d0g3lai96">
          Redondoland
        </p>
        <p className="mt-5 text-sm text-body" data-id="element-75" data-mp="36qhh702ou83u">
          © Redondoland 2026 — All rights reserved.
        </p>
        <p className="mt-2 text-sm text-body" data-id="element-76" data-mp="3ugbqj7nstejc">
          Support:{' '}
          <a href="mailto:redondoland1@gmail.com" className="transition-colors duration-150 ease-out hover:text-champagne" data-id="element-77" data-mp="398y6cw8527j">
            redondoland1@gmail.com
          </a>
        </p>

        <div className="mt-10 border-t border-charcoal-600 pt-8 text-left" data-id="element-78" data-mp="3qcdp2qb03rn4">
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-79" data-mp="29ynmjnzj5bfl">
            Important disclaimer
          </p>
          <p className="mt-4 text-[13px] leading-relaxed text-muted" data-id="element-80" data-mp="2ezut5jpxs4ko">
            BREAK FREE™ is an educational resource for personal growth, clarity and
            practical guidance. It is not a substitute for professional therapy,
            counseling or legal advice.
          </p>
          <p className="mt-3 text-[13px] leading-relaxed text-body" data-id="element-81" data-mp="3v8hp81cfiqpf">
            If you are in immediate physical danger, contact emergency services or the
            National Domestic Violence Hotline:{' '}
            <a href="tel:18007997233" className="font-semibold text-ivory-100 transition-colors duration-150 ease-out hover:text-champagne" data-id="element-82" data-mp="81fppw8pas47">
              1-800-799-7233
            </a>
            .
          </p>
        </div>
      </div>
    </footer>;
}